import './styles.scss';

interface ISliderProps {
  page: number;
  isFinal: boolean;
  setPage: (val: number) => void;
}

const Slider = ({ page, isFinal, setPage }: ISliderProps) => {
  const canGoPrev = page > 1;
  const canGoNext = !isFinal;

  const onPrev = () => {
    if (canGoPrev) {
      setPage(page - 1);
    }
  };

  const onNext = () => {
    if (canGoNext) {
      setPage(page + 1);
    }
  };

  return (
    <div className='slider'>
      <div
        className={`${
          canGoPrev ? 'slider__btn' : 'slider__disabled_btn'
        } icon-chevron-left`}
        onClick={onPrev}
      />
      <div
        className={`${
          canGoNext ? 'slider__btn' : 'slider__disabled_btn'
        } icon-chevron-right`}
        onClick={onNext}
      />
    </div>
  );
};

export default Slider;
